import { t } from "../../../i18n/translations";
import type { GameRoom } from "../types/multiplayer-core.types";

type SupportedLanguage = string;
type SupportedGroupType = "family" | "friends";

interface GroupContextInput {
  familyId?: string | null;
  familyName?: string | null;
  friendsGroupId?: string | null;
  friendsGroupName?: string | null;
  groupId?: string | null;
  groupName?: string | null;
  groupType?: SupportedGroupType | null;
}

export interface GroupMeta {
  groupType: SupportedGroupType;
  groupLabel: string;
  groupLabelLower: string;
  groupName: string;
  roomTitle: string;
}

export function resolveGroupContextMeta(
  context: GroupContextInput | null | undefined,
  language: SupportedLanguage,
): GroupMeta {
  const resolvedGroupType: SupportedGroupType =
    context?.groupType ||
    (context?.friendsGroupId || context?.friendsGroupName ? "friends" : "family");

  const groupLabel =
    resolvedGroupType === "friends"
      ? t("familiesFriends.groupTypeFriends", language)
      : t("familiesFriends.groupTypeFamily", language);
  const groupLabelLower = groupLabel.toLowerCase();
  const groupName =
    context?.familyName ||
    context?.friendsGroupName ||
    context?.groupName ||
    groupLabel;

  return {
    groupType: resolvedGroupType,
    groupLabel,
    groupLabelLower,
    groupName,
    roomTitle: `${groupLabel} ${t("multiplayer_lobby.quizRoom", language)}`,
  };
}

export function resolveRoomGroupMeta(
  room: Partial<GameRoom> | null | undefined,
  language: SupportedLanguage,
): GroupMeta {
  const explicitRoomType =
    (room as Partial<GameRoom> & { room_type?: SupportedGroupType | null })?.room_type || null;
  const derivedGroupType: SupportedGroupType =
    room?.family_id || room?.family_name
      ? "family"
      : room?.friends_group_id || room?.friends_group_name
        ? "friends"
        : explicitRoomType || "family";

  return resolveGroupContextMeta(
    {
      groupType: derivedGroupType,
      familyName: room?.family_name,
      friendsGroupName: room?.friends_group_name,
      groupName: room?.name || undefined,
    },
    language,
  );
}
